import { Platform } from "react-native";

import { isSafePostLoginRedirect } from "./isSafePostLoginRedirect";

type ExecutePostLoginRedirectParams = {
  clearPreAuthenticatedPath: () => void;
  redirectExternal: (url: string) => void;
  redirectInApp: (path: string) => void;
  redirectPath?: null | string;
};

const getNormalizedRedirectPath = (
  redirectPath?: null | string
): null | string => {
  if (!redirectPath) {
    return null;
  }

  const trimmedRedirectPath = redirectPath.trim();

  return trimmedRedirectPath && isSafePostLoginRedirect(trimmedRedirectPath)
    ? trimmedRedirectPath
    : null;
};

export const isInAppPatronRedirect = (redirectPath?: null | string) => {
  const normalizedRedirectPath = getNormalizedRedirectPath(redirectPath);

  return normalizedRedirectPath?.startsWith("/patron/") ?? false;
};

export const executePostLoginRedirect = ({
  clearPreAuthenticatedPath,
  redirectExternal,
  redirectInApp,
  redirectPath,
}: ExecutePostLoginRedirectParams) => {
  const normalizedRedirectPath = getNormalizedRedirectPath(redirectPath);

  if (!normalizedRedirectPath) {
    return false;
  }

  clearPreAuthenticatedPath();

  if (Platform.OS === "web") {
    redirectExternal(normalizedRedirectPath);
    return true;
  }

  if (isInAppPatronRedirect(normalizedRedirectPath)) {
    redirectInApp(normalizedRedirectPath);
    return true;
  }

  redirectExternal(normalizedRedirectPath);
  return true;
};
